import * as React from 'react'
import ResetPasswordForm from './ResetPasswordForm';
import { auth } from '../../../firebase';
import * as logger from '../../../helpers/logger';

class ResetPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      resetPasswordEmailSent: false
    };
  }

  handleResetPassword(values) {
    const { email } = values;
    auth.sendPasswordResetEmail(email).then(() => {
      this.setState({resetPasswordEmailSent: true})
    }).catch(error => {
      logger.error(error);
    });
  }

  render() {

    const { resetPasswordEmailSent } = this.state;
    return(
      <div className="section-default">
        <div className="container">
          {
            resetPasswordEmailSent &&
            <div className="notification is-primary">
              Reset password mail has been sent. Please check your email.
            </div>
          }
          <div>
              <ResetPasswordForm
                onSubmit={this.handleResetPassword.bind(this)}
                emailSent={resetPasswordEmailSent}
              />
          </div>
        </div>
      </div>
    )
  }
}
export default ResetPassword